import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import AnimatedBloqcubeLogo from '../../../components/Logo/AnimatedBloqcubeLogo';
import { Bar } from 'react-chartjs-2';
import { useFinanceDashboradDataQuery } from '../../../store/slices/apiSlice';

const TransactionCounts = ({ clinicalStudyId, studySiteIds, siteList, ...props }) => {
  const { data: dashboardData, isLoading } = useFinanceDashboradDataQuery({
    data: { preference: props.preference, clinicalStudyId, studySiteIds: studySiteIds?.join(',') },
  });

  const { lables, pending, succeeded, failed, fullLabels } = useMemo(() => {
    const lables = [];
    const fullLabels = [];
    const pending = [];
    const succeeded = [];
    const failed = [];

    if (dashboardData) {
      const dashboardSites = dashboardData.bySite;

      for (let id in siteList) {
        const site = siteList[id];
        const currentSite = dashboardSites[site.id];

        if (!currentSite) continue;

        const siteName = site?.siteName || '';
        fullLabels.push(siteName);
        
        // Truncate long labels to 20 characters
        const truncatedLabel = siteName.length > 20 
          ? `${siteName.substring(0, 17)}...` 
          : siteName;
        
        lables.push(truncatedLabel);
        pending.push(currentSite?.pending || 0);
        succeeded.push(currentSite?.succeeded || 0);
        failed.push(currentSite?.failed || 0);
      }
    }

    return {
      lables,
      fullLabels,
      pending,
      succeeded,
      failed,
    };
  }, [dashboardData, studySiteIds, siteList]);

  const allValuesZero = useMemo(() => {
    const allValues = [...pending, ...succeeded, ...failed];
    return allValues.length > 0 && allValues.every((value) => value === 0);
  }, [pending, succeeded, failed]);

  const options = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      datalabels: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function(context) {
            const dataIndex = context[0].dataIndex;
            return fullLabels[dataIndex] || context[0].label;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        min: 0,
        max: allValuesZero ? 10 : undefined,
        ticks: {
          stepSize: allValuesZero ? 2 : undefined,
          callback: function(value) {
            return Number.isInteger(value) ? value : '';
          }
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          maxTicksLimit: 10,
          callback: function(value, index) {
            const label = this.getLabelForValue(value);
            return label;
          }
        },
        afterFit: function(scale) {
          scale.width = Math.min(scale.width, 150);
        }
      }
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10
      }
    }
  };
  const data = {
    labels: lables,
    datasets: [
      {
        label: 'Succeeded',
        data: succeeded,
        borderColor: '#4CAF50',
        backgroundColor: '#E8F5E9',
      },
      {
        label: 'Pending',
        data: pending,
        borderColor: '#FFB300',
        backgroundColor: '#FFF8E1',
      },
      {
        label: 'failed',
        data: failed,
        borderColor: '#F44336',
        backgroundColor: '#FFEBEE',
      },
    ],
  };

  return (
    <Box
      onMouseDown={(e) => e.stopPropagation()}
      sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}
    >
      {isLoading && (
           <Box sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
             <Box sx={{ height: 250, width: 250 }}>
               <AnimatedBloqcubeLogo />
             </Box>
           </Box>
         )}
      {dashboardData && <Bar options={options} data={data} />}
    </Box>
  );
};

export default TransactionCounts;
